export class DownloadAllStatus {
    status: string = "default";
}
